import { Download } from '@mui/icons-material';
import { Box, Button, Card, Link, styled, Typography } from '@mui/material';
import FlexBetween from 'components/flexbox/FlexBetween';
import FileUpload from 'page-sections/user-list/FileUpload';
import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axiosInstance from 'utils/axios';

const StyledFlexBox = styled(FlexBetween)(({ theme }) => ({
    flexWrap: 'wrap',
    marginBottom: 20,
    [theme.breakpoints.down(500)]: {
        width: '100%',
        '& .MuiInputBase-root': {
            maxWidth: '100%',
        },
        '& .MuiButton-root': {
            width: '100%',
            marginTop: 15,
        },
    },
}));

const UserUpload = () => {
    const [error, setError] = useState();
    const [file, setFile] = useState(false);

    const navigate = useNavigate();

    const handleDropFile = useCallback(
        async (acceptedFiles, fileRejections) => {
            setError();
            fileRejections.forEach((file) => {
                file.errors.forEach((err) => {
                    console.log(err);
                    if (err.code === 'file-too-large') {
                        setError(`Error: ${err.message}`);
                    }

                    if (err.code === 'file-invalid-type') {
                        setError(`Error: ${err.message}`);
                    }
                });
            });
            if (acceptedFiles.length > 0) {
                setFile(true);
                const formData = new FormData();
                formData.append('file', acceptedFiles[0]);
                await axiosInstance
                    .post('/api/users/upload', formData, {
                        Headers: {
                            'Content-Type': 'multipart/ form-data',
                            Authorization: `Bearer ${localStorage.getItem(
                                'accessToken',
                            )}`,
                        },
                    })
                    .then(() => navigate(`/dashboard/admin/user-list`))
                    .catch((err) => console.log(err));
            }
        },
        [navigate],
    );

    return (
        <Box pt={2} pb={4}>
            <Card
                sx={{
                    padding: 5,
                }}
            >
                <StyledFlexBox>
                    <Typography variant="h5">Upload Users</Typography>
                    <Link
                        href="/assets/templates/Bulk Upload User.xlsx"
                        target="_blank"
                        download
                        underline="none"
                    >
                        <Button
                            size="small"
                            variant="contained"
                            endIcon={<Download />}
                        >
                            Download Template
                        </Button>
                    </Link>
                </StyledFlexBox>
            </Card>
            <Card sx={{ mt: 4 }}>
                <FileUpload onDrop={handleDropFile} error={error} file={file} />
            </Card>
        </Box>
    );
};

export default UserUpload;
